import { useNavigate } from "react-router-dom";

interface Props {
  title: React.ReactNode;
  showBack?: boolean;
  onBack?: () => void;
  rightSlot?: React.ReactNode;
}

const BackIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M15 5l-7 7 7 7"
      stroke="#111"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SubHeader = ({ title, showBack = true, onBack, rightSlot }: Props) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white h-[60px] shadow-[0_4px_20px_rgba(0,0,0,0.12)] flex items-center px-3 sticky top-0 z-30 shrink-0">
      {showBack && (
        <button
          type="button"
          aria-label="Back"
          onClick={() => (onBack ? onBack() : navigate(-1))}
          className="w-9 h-9 flex items-center justify-center bg-transparent border-0 mr-1"
        >
          <BackIcon />
        </button>
      )}
      <h1 className="font-sansation font-semibold text-[#111] text-[18px]">
        {title}
      </h1>
      {rightSlot && <div className="ml-auto">{rightSlot}</div>}
    </div>
  );
};

export default SubHeader;
